import csharpCourse from "./CsharpCourse";

const nxOpenCourse = {
    id: "nx-open",
    name: "NX Open",
syllabusPdf: "/syllabus/NX-Open-Syllabus.pdf",

    hero: {
        title: "NX Customization & Design Automation Using NX Open",

        subtitle: "Live & Interactive Online Training",

        logo: "/nx-open-logo.webp",
        points: [
            "Master NX customization through API programming with C# .NET. Automate 3D modeling, assembly design, and drawing creation in Siemens NX using NX Open.",

            "Ideal for engineers and CAD professionals seeking high-salary roles and fast-track career growth through advanced NX automation and customization skills.",

            "Learn everything you need to shift your career from manual CAD design to in-demand NX customization and automation using C# and the NX Open API.",

            "We start from the basics of computer programming, so even beginners with no prior coding experience can learn and excel.",

            "Get training and career guidance from the Industry Experts working in top tech companies."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "CAD Design Engineers with 4 to 5 years of experience typically earn a CTC between ₹5 lakh and ₹10 lakh. In contrast, CAD Developers with similar experience can secure salaries ranging from ₹20 lakh to ₹30 lakh."
        },
        {
            title: "Good Demand",
            description:
                "While CAD Design is a well-known skill among mechanical engineers, there is intense competition for design jobs. On the other hand, CAD Automation & Customization is a niche expertise, with only a few engineers."
        },
        {
            title: "Easier To Learn",
            description:
                "While CAD Design is generally easier to learn, CAD Automation & Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training."
        }
    ],

    whyLearn: [
        {
            title: "High-Demand Skillset",
            description:
                "Companies using Siemens NX are actively hiring professionals skilled in NX automation and API development to boost design efficiency."
        },
        {
            title: "Develop Intelligent CAD Tools",
            description:
                "Build intelligent design applications that adapt to inputs, generate variants, and eliminate human error."
        },
        {
            title: "Automate Repetitive Tasks",
            description:
                "Save hours by automating complex modeling, assembly, and drafting processes through custom scripts and tools."
        },
        {
            title: "Work Smarter, Not Harder",
            description:
                "Focus on innovation rather than repetitive CAD work — automation lets you build tools that do the design work for you."
        },
        {
            title: "Fast-Track Career Growth",
            description:
                "Stand out from traditional CAD engineers and move into senior roles like CAD Automation Engineer, NX Developer, or R&D Engineer."
        },
        {
            title: "Get Noticed by Top Companies",
            description:
                "Tech-driven organizations in automotive, aerospace, and heavy machinery actively seek NX Open experts."
        },
        {
            title: "Build Custom Design Tools",
            description:
                "Create tailor-made features and apps inside NX that match your organization’s exact design needs."
        },
        {
            title: "Learn Real-World C# Programming",
            description:
                "Gain hands-on experience with C# .NET — one of the most in-demand programming languages in engineering and software fields."
        },
        {
            title: "No Coding Background Needed",
            description:
                "Start from scratch — you’ll learn programming fundamentals before diving into NX Open, making it beginner-friendly."
        },
        {
            title: "Mentorship from Industry Experts",
            description:
                "Learn from professionals working on real-world NX automation projects — with guidance on code, tools, and career pathways."
        }
    ],

    syllabus: [

        {
            name: "C#.NET",
            modules: csharpCourse.syllabus
        },
        {
            name: "NX Open",
            modules: [
                {
                    number: 1,
                    title: "NX Open Concepts & Architecture",
                    topics: [
                        "Sessions and Parts",
                        "Objects and Tags",
                        "Factory Objects",
                        "Object Collections",
                        "The Builder Pattern",
                        "Exploring NX Open Using Journaling"
                    ]
                },
                {
                    number: 2,
                    title: "Positions, Vectors, and Points",
                    topics: [
                        "Point3d Objects",
                        "Vector3d Objects",
                        "Smart Points"
                    ]
                },
                {
                    number: 3,
                    title: "Working with Curves",
                    topics: [
                        "Lines",
                        "Associative Line Features",
                        "Arcs and Circles",
                        "Associative Arc Features",
                        "Conic Section Curves",
                        "Studio Splines",
                        "Sketches"
                    ]
                },
                {
                    number: 4,
                    title: "Simple Solids and Sheet Bodies",
                    topics: [
                        "Creating Primitive Solids",
                        "Creating Sections",
                        "Extruded Bodies",
                        "Revolved Bodies"
                    ]
                },
                {
                    number: 5,
                    title: "Object Properties & Methods",
                    topics: [
                        "NX Object Properties",
                        "Curve and Edge Properties",
                        "Face Properties"
                    ]
                },
                {
                    number: 6,
                    title: "Units & Expressions",
                    topics: [
                        "Understanding Units in NX",
                        "Expressions Overview",
                        "Creating and Managing Expressions",
                        "Using Expressions to Define Feature Parameters"
                    ]
                },
                {
                    number: 7,
                    title: "Assemblies",
                    topics: [
                        "Introduction to NX Assemblies",
                        "The Obligatory Car Example (Understanding Practical Use)",
                        "Trees, Roots, and Leaves (Assembly Structure)",
                        "Components and Prototypes",
                        "Cycling Through an Assembly",
                        "Indented Listings in Assemblies",
                        "Component Positions & Orientations",
                        "Object Occurrences and Context",
                        "Creating and Managing Assemblies",
                        "Changing Reference Sets",
                        "Additional Advanced Topics in Assemblies"
                    ]
                },
                {
                    number: 8,
                    title: "Drawings & Annotations",
                    topics: [
                        "Introduction to Drawing Automation in NX",
                        "Sheets & Sheet Properties",
                        "Views & View Properties",
                        {
                            title: "Dimensioning",
                            subTopics: [
                                "Linear",
                                "Radial",
                                "Angular"
                            ]
                        },
                        "GD&T (Geometric Dimensioning and Tolerancing)",
                        "Adding Notes and Labels",
                        "Automating Title Blocks"
                    ]
                },
                {
                    number: 9,
                    title: "Selecting NX Objects",
                    topics: [
                        "Using Selection Dialogs",
                        "Working with Select Object Blocks",
                        "Selecting Faces, Curves, and Edges Using Collectors"
                    ]
                },
                {
                    number: 10,
                    title: "Block UI Styler",
                    topics: [
                        "When to Use Block-Based Dialogs",
                        "How Block-Based Dialogs Work",
                        "The Overall Process of Dialog-Based Interfaces",
                        "Using Block UI Styler Effectively",
                        "Working with Controls, Groups, and Properties",
                        "Getting Integer, Double, and String Input from Users",
                        "Receiving Point3d and Vector3d Inputs in Dialogs",
                        "Selecting Bodies, Faces, and Edges Through Dialog",
                        "Handling Events: initialize, apply, okay, and update"
                    ]
                },
                {
                    number: 11,
                    title: "Using Remote Applications",
                    topics: [
                        "Client-Side Programming Concepts",
                        "Server-Side Programming in NX Open",
                        "Executing Commands on Remote NX Systems"
                    ]
                },
                {
                    number: 12,
                    title: "Exception Handling in NX Open",
                    topics: [
                        "Understanding Exceptions in C# and NX",
                        "Examples of Unhandled Exceptions",
                        "Properly Handling Exceptions",
                        "Accessing Exception Properties",
                        "Working with NX-Specific Exceptions",
                        "Strategies to Avoid Exceptions",
                        "The Role of the finally Block"
                    ]
                },
                {
                    number: 13,
                    title: "Troubleshooting NX Open Development",
                    topics: [
                        "Reading and Using the NX Log File",
                        "Solving Invalid Attempt to Load Library Errors",
                        "Resolving is not a member of NX Open Issues",
                        "Fixing Unable to Load Referenced Library Errors",
                        "Dealing with Failed to Load Image Problems"
                    ]
                },
                {
                    number: 14,
                    title: "Post-Training Support",
                    topics: [
                        "Real-World Project Support and Guidance",
                        "Resume Building & Interview Preparation",
                        "Job Assistance & Long-Term Career Guidance"
                    ]
                }]
        }
    ],

    videos: [
        {
            category: "CAD Customization & Automation",
            title: "CAD Customization And Automation Session",
            videoUrl: "https://www.youtube.com/embed/VpcpMwvQJy4"
        },
        {
            category: "For students new to Programming.",
            title: "Day 1: Programming Class C#.NET",
            videoUrl: "https://www.youtube.com/embed/7U2z7LUMH9g"
        },
        {
            category: "NX Customization sample - Create parts with respect to other parts",
            title: "NX customization with NX Open API Sample Project: Gasket Stopper Assembly",
            videoUrl: "https://www.youtube.com/embed/q-JiBFRbCio"
        },
        {
            category: "NX Customization with NX OPEN API Sample Project : Complete knuckle joint design from the scratch.",
            title: "NX Customization Training. NX Open API Training, CAD Customization Training. Sample Students Project",
            videoUrl: "https://www.youtube.com/embed/XXTr_xjRZto"
        },
        {
            category: "NX Open y features from one part and create matching features in another part in Assembly.",
            title: "NX Customization Sample",
            videoUrl: "https://www.youtube.com/embed/Y5yWKP62EY4"
        },
        {
            category: "NX customization & Automation Sample Project - Batch Export all the part files into IGES and STEP files",
            title: "NX Open API Programming - Batch Export to IGES & STEP",
            videoUrl: "https://www.youtube.com/embed/URpFRWwxFD0"
        }
    ],

    faq: [
    {
        question: "What is NX Customization?",
        answer: "NX Customization is the process of tailoring Siemens NX software for specific design and engineering needs, involving user interface modifications, workflow automation, integration with other tools, and specialized add-ons to enhance productivity and efficiency."
    },
    {
        question: "How Much Salary?",
        answer: [
            "NX Developers often receive significantly higher salaries. This is because they create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.",
            "For a detailed explanation, please view the video located at this page."
        ]
    },
    {
        question: "I have NX design experience",
        answer: [
            "Having NX experience is an advantage. It allows you to fully leverage your design skills and familiarity with NX tools.",
            "You can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings.",
            "In the future, your background can position you to lead teams of both design engineers and developers, bridging the gap between design excellence and cutting-edge automation solutions."
        ]
    },
    {
        question: "Job Guaranteed?",
        answer: [
            "Generally No.",
            "Sometimes Yes.",
            "Please speak to the coordinator for more details."
        ]
    },
    {
        question: "Which programming language?",
        answer: "For CAD tools such as NX, AutoCAD, SolidWorks, Inventor, etc., C#.NET or VB.NET are well-suited programming languages."
    },
    {
        question: "Job opportunities?",
        answer: "This skill is quite rare, with a limited number of professionals available in the market compared to the growing demand. Consequently, the job opportunities in this field are in high demand and offer promising prospects."
    }
],
};

export default nxOpenCourse;